import PropTypes from 'prop-types';
import { createContext, useMemo } from 'react';

import config from '../config';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const ConfigContext = createContext(undefined);

export function ConfigProvider({ children }) {
  const { state, setState, setField, resetState } = useLocalStorage('zenigma_erp_new', config);

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}

ConfigProvider.propTypes = { children: PropTypes.node };
